<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible & !purchaseFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.businessNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <!-- <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
              v-model="listQuery.businessName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务品牌</span>
            <el-input
              v-model="listQuery.businessBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务型号</span>
            <el-input
              v-model="listQuery.businessModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">序列号</span>
            <el-input
              v-model="listQuery.businessSerial"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div> -->

          <div class="filter-box">
            <span class="label">材料编号</span>
            <el-input
              v-model="listQuery.materialNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
            />
          </div>
          <div class="filter-box">
            <span class="label">材料品牌</span>
            <el-input
              v-model="listQuery.materialBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
            />
          </div>
          <div class="filter-box">
            <span class="label">材料名称</span>
            <el-input
              v-model="listQuery.materialName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
            />
          </div>
          <div class="filter-box">
            <span class="label">材料型号</span>
            <el-input
              v-model="listQuery.materialModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
            />
          </div>
          <div class="filter-box">
            <span class="label">材料代码</span>
            <el-input
              v-model="listQuery.materialCode"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
            />
          </div>

          <div class="filter-box">
            <span class="label">申请人</span>
            <el-select :filterable="true" v-model="listQuery.createUser" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleCreateUserFocus" @change="handleFilter">
              <el-option
                v-for="item in createUserOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>

          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('purchase')"
          >
            生成采购单
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_EDIT` }"
            type="primary"
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleBatchUpdate"
          >
            批量编辑
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_RETRUN` }"
            type="primary"
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleBatchReturn"
          >
            退回预采购信息
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
                <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
                <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="rf => { if (rf) tableDataRef[0] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :tableRowClassName="tableRowClassName"
              :showSelection="true"
              :showSummary="true"
              :isShowPagination="false"
              :handleDefaultWidth="120"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              style="height:calc(100% );overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:max="scope" >
                <span>
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    v-if="scope.row.material?.max"
                  >
                    <template #content> {{scope.row.material?.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.material?.max?.updateTime}}</template>
                    <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
                  </el-tooltip>
                  {{ maxMinCalc(scope.row.material, 'max') }}
                </span>
              </template>
              <template v-slot:min="scope" >
                <span>
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    v-if="scope.row.material?.min"
                  >
                    <template #content> {{scope.row.material?.min?.supplier?.name}}<br /> 最后修改时间：{{scope.row.material?.min?.updateTime}}</template>
                    <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
                  </el-tooltip>
                  {{ maxMinCalc(scope.row.material, 'min') }}
                </span>
              </template>
              <template v-slot:operation-action="scope">
                <el-link
                  v-permission="{ pkey: `${permissionName}_EDIT` }"
                  v-if="scope.row.status === '待处理'"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('edit', scope.row)"
                >
                  编辑
                </el-link>

                <template v-if="scope.row.status !== '待处理'">
                  <span
                    v-if="scope.row.status !== '采购拒绝'"
                    href="javascript:void(0);"
                    class="mr-10"
                    style="color: green "
                  >
                  {{ scope.row.status }}
                </span>
                 <span
                  v-else
                  href="javascript:void(0);"
                  class="mr-10"
                  style="color: #999 "
                >
                  已拒绝
                </span>
                </template>
                <el-link
                  v-permission="{ pkey: `${permissionName}_DELETE` }"
                  v-if="scope.row.status === '采购拒绝'"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="danger"
                  @click="handleCommand('delete', scope.row)"
                >
                  删除
                </el-link>
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{ active: activeTab === item.id }" @click="handleTabClick(item)">
                    {{ item.name }}
                  </li>
                </ul>
              </div>
              <PriceInfo v-if="activeTab === 1" ref="PriceInfo" :id="activeMaterialId" formPage="material" :dataId="activeId" :materialInfo="materialInfo"/>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :selectRows="selectRows"
      :dialogFormVisible="dialogFormVisible"
      :api="'purchaseInAdvance'"
      :isEdit="isEdit"
      :commandState="commandState"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <PurchaseForm
      v-if="purchaseFormVisible"
      :dialogFormVisible="purchaseFormVisible"
      :api="'purchase'"
      :selectionArray="selectionArray"
      @update:visibel="() => purchaseFormVisible = false"
      @submit="handleSubmit()"
    />
    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible && !purchaseFormVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
  </div>
</template>
<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { deleteById, getPageList, putUrl } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { ArrayRowsItem } from '@/model/Index'

import FormComponent from './Form.vue'
import TableList from '@/components/common/TableList.vue'
import PurchaseForm from '../purchase/From.vue'

import PriceInfo from './priceInfo/Index.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { EditFormData } from './EditFieldFrom'

import { TableField } from './FieldTable'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import { maxMinCalc } from '@/views/purchasManage/materialInfo/FieldTable'

export default defineComponent({
  name: 'PurchaseinAdvance',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    PriceInfo,
    PurchaseForm
  },
  setup() {
    const { t } = useI18n()
    const PriceInfo = ref(null)
    const tableDataRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_PURCHASEINADVANCE,
      permissionName: permissionName.PURCHASEINADVANCE,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: cloneDeep(FromFieldData),
      EditFormData: cloneDeep(EditFormData),

      columnAllData: TableField,

      activeId: 0,
      activeRow: {},
      selectRows: [],
      list: [],
      total: 0,
      listLoading: false,
      maxMinCalc,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,

      tabList: [
        { name: '价格信息', id: 1 }
      ],
      activeTab: 1,
      activeMaterialId: 0,
      materialInfo: {} as any,

      salesManId: '',
      newHpx: 0,
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      createUserOption: [],
      selectionArray: [],
      commandState: 'edit',
      selectcCustomerCompanyId: 0,
      chargeVisible: false,
      achieveType: '',
      accountOption: [],
      chargeForm: {
        accountId: '',
        amount: '',
        date: ''
      },
      rules: {
        accountId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        amount: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        date: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      statusOption: [],
      purchaseFormVisible: false,
      isEdit: false,

      async handleCommand(command: string, val?: any) {
        dataMap.commandState = command
        if (command !== 'column') {
          dataMap.activeRow = val
          dataMap.activeId = val ? val.id : 0
          dataMap.activeMaterialId = val ? val.materialId : 0
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'purchase':
            dataMap.selectRows = dataMap.selectionArray
            if (!dataMap.selectionArray.length) {
              return ElMessage.error('请选择数据！')
            }
            if (!dataMap.canHandle()) {
              return ElMessage({
                message: '请选择待处理的数据操作！',
                type: 'error',
                duration: 2000
              })
            }
            dataMap.purchaseFormVisible = true
            break
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row?.id || 0
        dataMap.activeMaterialId = row?.materialId || 0
        if (row) {
          dataMap.materialInfo = {
            ...row,
            no: row.materialNo,
            name: row.materialName,
            model: row.materialModel
          }
        }
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabCommand(command: string) {
        if (this.activeTab === 1) {
          if (PriceInfo.value && PriceInfo.value) {
            ;(PriceInfo.value as any).handleCommand(command)
          }
        }
      },
      getList() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getPageList('purchaseInAdvance', { ...dataMap.listQuery }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((item: any) => {
              const temp = item
              if (item.business) {
                Object.assign(temp, {
                  businessNo: item.business.no,
                  businessName: item.business.name,
                  businessBrand: item.business.brand,
                  businessAmount: item.business.amount,
                  businessModel: item.business.model,
                  businessSerial: item.business.serial
                })
              }

              if (item.material) {
                Object.assign(temp, {
                  materialNo: item.material.no,
                  materialClass: item.material.materialClass,
                  materialUnit: item.material.materialUnit,
                  materialStandard: item.material.standard,
                  materialId: item.material.id,
                  materialBrand: item.material.brand,
                  materialName: item.material.name,
                  materialModel: item.material.model,
                  materialCode: item.material.code,
                  materialParameter: item.material.parameter,
                  materialDevice: item.material.device,
                  materialMark: item.material.mark
                })
              }
              return temp
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.handleRowClick(dataMap.list[0])
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.selectRows = []
        dataMap.isEdit = false
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleBatchUpdate() {
        dataMap.selectRows = dataMap.selectionArray
        if (!dataMap.selectionArray.length) {
          return ElMessage({
            message: '请选择需要编辑的数据',
            type: 'error',
            duration: 2000
          })
        }
        if (!dataMap.canHandle()) {
          return ElMessage({
            message: '请选择待处理的数据操作！',
            type: 'error',
            duration: 2000
          })
        }
        dataMap.isEdit = true
        dataMap.dialogFormVisible = true
      },
      handleBatchReturn() {
        dataMap.selectRows = dataMap.selectionArray
        if (!dataMap.selectionArray.length) {
          return ElMessage({
            message: '请选择需要退回的数据',
            type: 'error',
            duration: 2000
          })
        }
        if (!dataMap.canHandle()) {
          return ElMessage({
            message: '请选择状态为【待处理】的数据操作！',
            type: 'error',
            duration: 2000
          })
        }
        ElMessageBox.prompt(
          '退回理由：',
          '提交',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger'
          }
        ).then((params: any) => {
          const { value } = params
          const ids = dataMap.selectRows.map((kk: any) => kk.id)
          putUrl('purchaseInAdvance/reject', { reject: value, ids }).then(() => {
            // if (result.success) {
            dataMap.getList()
            ElMessage({
              message: '操作成功！',
              type: 'success',
              duration: 1000
            })
            // } else {
            //   dataMap.cancelBusinessVisible = true
            //   dataMap.cancelBusinessList = result.steps
            // }
          })
        })
      },
      handleUpdate(row: any) {
        dataMap.selectRows = [row]
        if (!dataMap.canHandle()) {
          return ElMessage({
            message: '请选择状态为待处理的数据操作！',
            type: 'error',
            duration: 2000
          })
        }
        dataMap.isEdit = true
        dataMap.activeId = row ? row.id : 0
        dataMap.dialogFormVisible = true
      },
      canHandle() {
        for (let i = 0; i < dataMap.selectRows.length; i++) {
          const item = dataMap.selectRows[i]
          if (item.status !== '待处理') {
            return false
          }
        }
        return true
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('purchaseInAdvance', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/PurchaseInAdvanceStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
      },
      handleCreateUserFocus() {
        getUrlList('user/dropdown/availableUses').then((res: any) => {
          dataMap.createUserOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      tableRowClassName({ row }: any) {
        if (!row.status) {
          return undefined
        }
        switch (row.status) {
          case '待处理':
            return 'row-red'
          case '采购拒绝':
            return 'row-gray'
          default:
            return undefined
        }
      }
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./purchasManage/purchaseInAdvance',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(async() => {
      mixinData.initHeight()

      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, tableDataRef }
  }
})
</script>
<style lang="scss">
.grid-layout-container {
  .vue-grid-item {
    background: #666;
  }
}
</style>
<style lang="scss" scope>
.statusStyle {
  .status {
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color: #fff;
  }
}

.redStatusStyle {
  .icon-tubiao-40 {
    color: #E74228;
  }

  .status {
    background-color: #E74228;
  }
}

.yellowStatusStyle {
  .icon-tubiao-40 {
    color: #F3D03C;
  }

  .status {
    background-color: #F3D03C;
  }
}

.warming-fp {
  border-radius: 4px;
  border: 1px solid $red;
  color: $red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
